// extracted by mini-css-extract-plugin
var _1 = "SelectTags-moduletag__EHKOW Tag-moduleTag__FLr9H";
export { _1 as "tag" }
